<template>
    <div class="search-results-wrapper">
        <div v-if="hasResults" class="pb-3">
            <strong>{{ results.locations.length }}</strong>
            {{ resultText }}
            <strong>{{ selectedRegion.label }}</strong>
        </div>

        <div v-if="!hasResults">
            {{ resultText }}
        </div>

        <div class="container">
            <location-block v-for="location in results.locations" :key="location.code" :item="location"
                            v-on="$listeners"></location-block>

            <h3 v-if="hasResults">{{ resultsWithoutLocation }}</h3>

            <location-block v-for="location in results.search_results" :key="location.code" :item="location"
                            v-on="$listeners"></location-block>

            <template v-if="hasNoResults">
                <h3 class="pt-3 mb-1">{{ noFound }}</h3>
                <p>{{ noFoundText }}</p>
                <a class="btn btn-primary" :href="searchQuery">{{ extendedSearchButton }}</a> &nbsp;
                <a class="btn btn-secondary" :href="`/${languageId}/contact-0`">{{ contactButton }}</a>
            </template>
        </div>
    </div>
</template>

<script>

import LocationBlock from "./LocationBlock";

export default {
    name: "SearchResults",

    components: {LocationBlock},

    props: ['results', 'selectedRegion', 'selectedCategory', 'selectedFilter', 'loading', 'languageId', 'searchPageUrl'],

    data() {
        return {
            resultsWithoutLocation: window.Drupal.t('Results without location'),
            noFound: window.Drupal.t('Found nothing?'),
            noFoundText: window.Drupal.t('Change your search query'),
            extendedSearchButton: window.Drupal.t('Advanced search'),
            contactButton: window.Drupal.t('Contact us'),
            resultTextFirst: window.Drupal.t('searchresults in'),
        }
    },

    computed: {
        selectedCategoryNames() {
            if(!_.isEmpty(this.selectedCategory.label)) {
              return this.selectedCategory.label
            }

            var names = this.results.categories.map(function (category) {
              return category.name
            });

            return _.join( names, ', ');
        },
        searchQuery() {
            return `${this.searchPageUrl}?vneml_prod_${this.languageId}[query]=${this.selectedRegion.label}`;
        },

        hasResults() {
            if (!_.isEmpty(this.results)) {
                return (this.results.locations.length > 0 || this.results.search_results.length > 0);
            }

            return false;
        },

        hasNoResults() {
            return ((_.isEmpty(this.results) && !this.loading) || (!_.isEmpty(this.results)));
        },

        resultText() {
            if (!this.hasResults && this.loading) {
                return `Loading ...`;
            }

            if (!this.hasResults && !this.loading) {
                return ``;
            }

            return !_.isEmpty(this.results) ? ` ${this.resultTextFirst} ` : '';
        }
    }
}
</script>
